
import {PathName} from "@/constant/routeData"

export default {
  name: "HomeHeader",
  data() {
    return {
      PathName: PathName,
    }
  },
  computed: {
    username() {
      return this.$store.getters.userName;
    },

    picture() {
      return this.$store.state.login.picture;
    },
  },
  methods: {
    loginOutFun() {
      this.$store.commit("CLEAR_TOKEN");
      this.$router.push({name: PathName.Login});
    },

    changePassword() {
      this.$store.commit('UNVISIBLE_SIDE', false)
      this.$router.push({name: PathName.SelfPassword});
    },
  },
};
